import { render, staticRenderFns } from "./PricingTables.vue?vue&type=template&id=8cd7c3dc&"
import script from "./PricingTables.vue?vue&type=script&lang=js&"
export * from "./PricingTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports